import { Link } from 'react-router-dom';
import { useNotifications } from '../../contexts/NotificationContext';
import { NotificationItemRow } from './NotificationItem';

type Props = { onClose: () => void };

export const NotificationDropdown = ({ onClose }: Props) => {
  const { recent, markRead, markAllRead, unreadCount } = useNotifications();
  const latest = recent.slice(0, 5);
  return (
    <div className="absolute right-0 top-full mt-2 w-[360px] overflow-hidden rounded-2xl border border-slate-200 bg-white text-slate-900 shadow-xl">
      <div className="flex items-center justify-between border-b border-slate-100 bg-slate-50 px-4 py-3">
        <p className="text-sm font-black text-[#000080]">Notifications {unreadCount ? <span className="rounded-full bg-[#FF9933] px-2 py-0.5 text-[10px] text-[#000080] ml-1">{unreadCount}</span> : null}</p>
        <button onClick={() => void markAllRead()} className="text-xs font-black text-[#138808] hover:underline">Mark all read</button>
      </div>
      <div className="max-h-[420px] overflow-y-auto p-2">
        {latest.length === 0 ? (
          <p className="p-6 text-center text-xs text-slate-500">No notifications yet.</p>
        ) : (
          <ul className="grid gap-2">
            {latest.map((n) => (
              <li key={n.id}>
                <NotificationItemRow
                  notification={n}
                  compact
                  onClick={() => { if (!n.is_read) void markRead(n.id); onClose(); }}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="border-t border-slate-100 bg-slate-50 px-4 py-2 text-right">
        <Link onClick={onClose} to="/notifications" className="text-xs font-black text-[#000080] hover:text-[#FF9933]">View all →</Link>
      </div>
    </div>
  );
};
